"use client";

import { useState } from "react";

interface CommandCopyButtonProps {
  command: string;
}

export default function CommandCopyButton({ command }: CommandCopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(command);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="bg-gray-900 rounded-lg p-4 flex items-center justify-between">
      <code className="text-lime-400 font-mono text-sm flex-1">{command}</code>
      <button
        onClick={handleCopy}
        className="ml-4 px-4 py-2 bg-lime-400 text-gray-900 rounded-lg text-sm font-medium hover:bg-lime-300 transition-colors flex items-center gap-2"
      >
        {copied ? (
          <>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            Copied!
          </>
        ) : (
          <>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
              />
            </svg>
            Copy Command
          </>
        )}
      </button>
    </div>
  );
}
